import { mainFailureFactorsChartCalculation } from "./common/main-failure-factors-chart-calculation";

const transformData = [
    {
        name: 'Family & friends',
        value: 'Item 1',
        keyQuestion: 'question28', 
    },
    {
        name: 'Business Angels',
        value: 'Item 2',
        keyQuestion: 'question22',
    },
    {
        name: 'Crowdfunding',
        value: 'Item 3',
        keyQuestion: 'question30',
    },
    {
        name: 'Incubators and Accelerators',
        value: 'Item 4',
        keyQuestion: 'question34',
    },
    {
        name: 'NGO’s loans',
        value: 'Item 5',
        keyQuestion: 'question38',
    },
    {
        name: 'NGO’s grants',
        value: 'Item 6',
        keyQuestion: 'question42',
    },
    {
        name: 'Public subsidies',
        value: 'Item 7',
        keyQuestion: 'question46',
    },
    {
        name: 'Public grants',
        value: 'Item 8',
        keyQuestion: 'question50',
    },
    {
        name: 'Venture capital',
        value: 'Item 9',
        keyQuestion: 'question54',
    },
    {
        name: 'Microfinance',
        value: 'Item 10',
        keyQuestion: 'question58',
    },
    {
        name: 'Financial institutions (banks)',
        value: 'Item 11',
        keyQuestion: 'question62',
    },
    {
        name: 'Other',
        value: 'other',
        keyQuestion: 'question66',
    },
];

/**
 * 
 * @param props 
 */
export const baselineMainFailureFactorsChartCalculation = (props: any) => {
    return mainFailureFactorsChartCalculation(props.baselineSubmissions, transformData) as Highcharts.Options;
}